module.exports = __webpack_public_path__ + "img/6.c6ebe30f.png";